<template>
  <div>
  <v-dialog v-model="show" max-width="800px">
    <v-card>
      <v-card-title>Modell erstellen</v-card-title>
      <v-container>
        <v-row class="mx-2">
          <v-col class="align-center justify-space-between" cols="12">
            <v-row align="center" class="mr-0">
              <v-text-field v-if="!addCharacteristic" placeholder="Name" v-model="fileName"></v-text-field>
            </v-row>
            <v-row align="center" class="mr-0">
              <v-select
                v-model="selectedFolder"
                :items="folders"
                item-text="folderName"
                item-value="id"
                label="Ordner wählen"
                hint="Es können nur Ordner mit Schreibberechtigung gewählt werden"
                persistent-hint
              ></v-select>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-switch v-model="addCharacteristic" label="Prozesssteckbrief hinzufügen"></v-switch>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-btn id="leftButton" text @click.stop="show=false">Abbrechen</v-btn>
        <v-btn id="rightButton" color="primary" @click.stop="createProcessModel()" :disabled="selectedFolder == null || fileName == null">Erstellen</v-btn>
      </v-card-actions>
    </v-card>
    
  </v-dialog>
  <ProcessCharacteristicsDialog ref="newCharacteristics" :openFromProcess="true"/>
  </div>
</template>

<script>
import ProcessCharacteristics from "../ProcessMap/ProcessCharacteristics.vue";
import ProcessCharacteristicsDialog from '../ProcessMap/ProcessCharacteristicsDialog.vue';
import newProcessService from "./new-process-service";
import processMapService from '@/components/processMapService.js';
export default {
    props: {
        value: Boolean,
        folders: Array
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        }
    },
    data() {
        return {
            fileName: null,
            selectedFolder: null,
            addCharacteristic: false,
            characteristics: null
        };
    },
    watch:{
      addCharacteristic(){
        if(this.addCharacteristic) this.openCharacteristicDialog();
      }
    },
    methods: {
        createProcessModel() {
            this.show = false;
            let fileName = this.fileName != null ? this.fileName : this.characteristics.name;
            const router = this.$router;
            newProcessService
                .createfile(fileName)
                .then(result => {
                const uuid = result.data;
                this.$emit("linkProcessToFolder", {
                    folderId: this.selectedFolder,
                    uuid: uuid
                });
                if(this.characteristics) this.characteristics.connectedModel = uuid;
                if(this.addCharacteristic){
                  processMapService.addProcessCharacteristic(this.characteristics).then(res => {
                    router.push({ name: "modeling", params: {
                          isNew: true,
                          uuid: uuid
                      } });
                  })
                }else{
                  router.push({ name: "modeling", params: {
                          isNew: true,
                          uuid: uuid
                      } });
                }

                
            })
                .catch(e => console.log("error: " + e));
        },
        openCharacteristicDialog(item){
          this.$refs.newCharacteristics.open(item, false, this.fileName).then(res =>{
            this.characteristics = res;
            this.fileName = this.characteristics.name;
          }).catch(e => this.addCharacteristic = false)
        },
    },
    components: { ProcessCharacteristics, ProcessCharacteristicsDialog }
};
</script>